export default __webpack_public_path__ + "static/media/robert-graham@2x.47d3c22d.png";